async function getCartJson(){
  const response = await fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .catch(err => console.log(err))

  return response;
}

async function cartCheckoutClick() {
  const cartJson = await getCartJson();
  
  var checkoutInput = {
    "items" : [],
    "totalPrice": cartJson.total_price
  };
  
  let items_subtotal_price = cartJson["items_subtotal_price"];
  items_subtotal_price = items_subtotal_price/100;
  if(giftCardAvailableBalance < items_subtotal_price){
    if($('#giftCardError').length <= 0) $('<p style="color:red" id="giftCardError">Giftcard balance not available for cart amount</p>').insertAfter("#checkoutWithGiftCard");
    if(window.location.pathname.includes("/cart")){
      if($('#giftCardErrorCartPage').length <= 0){
        let checkoutWithGiftCardParent = $('#checkoutWithGiftCardCartPage').parent();
        $('<p style="color:red" id="giftCardErrorCartPage">Giftcard balance not available for cart amount</p>').insertAfter(checkoutWithGiftCardParent);
      }
    }
    return;
  }
  
  let items = cartJson["items"];
  for(let i=0;i<items.length;i++){
    let item = items[i];
    let variantId = item["id"];
    let quantity = item["quantity"];
    let lineItem = {};
    lineItem["quantity"] = quantity;
    lineItem["variantId"] = variantId;
    checkoutInput.items.push(lineItem);
  }
  let checkoutPayload = {};
  checkoutPayload["checkoutInput"] = checkoutInput;
  // checkoutPayload["discountCodes"]=[giftCardCode];
  console.log("checkoutPayload: "+JSON.stringify(checkoutPayload));
  checkOutRedirectApi(checkoutPayload.checkoutInput);
}


function checkOutRedirectApi(jsonData) {
  console.log(jsonData);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(jsonData),
    redirect: 'follow'
  };

  let checkoutWithGiftCardApi = "/apps/sso/moas/rest/checkout/getcheckouturl?giftCard="+[giftCardCode];
  fetch(checkoutWithGiftCardApi, requestOptions)
  .then(response => response.text())
  .then(result => {
    console.log(result);
    if(JSON.parse( result ).error == undefined) {
      console.log(JSON.parse( result ).checkoutUrl);
      let checkoutUrl = JSON.parse( result ).checkoutUrl;
      checkoutUrl = checkoutUrl.replace("https://brandshop-303e.myshopify.com", "https://ukprimoshop.bacardi.uk");
      window.location.replace(checkoutUrl);
    } else {
      //initiate normal checkout
    }
  })
  .catch(error => console.log('error', error));
}